import { Link } from "react-router-dom";
import { Calendar, Tag } from "lucide-react";

export const formatDate = (d) =>
  new Date(d).toLocaleDateString("en-US", { month: "long", day: "numeric", year: "numeric" });

export default function StoryCard({ story, className = "" }) {
  return (
    <article className={`story-card bg-white rounded-lg overflow-hidden shadow-[0_10px_40px_-20px_rgba(36,35,29,0.25)] flex flex-col h-full ${className}`}>
      <Link to={`/stories/${story.slug}`} className="block overflow-hidden aspect-[16/10]">
        <img src={story.image} alt={story.title} className="h-full w-full object-cover" loading="lazy" />
      </Link>
      <div className="p-7 flex flex-col flex-1">
        <div className="flex flex-wrap items-center gap-x-4 gap-y-1 text-xs text-[#878680] font-medium mb-4">
          <span className="inline-flex items-center gap-1.5">
            <Calendar size={13} className="text-[#4BAF47]" /> {formatDate(story.created_at)}
          </span>
          <span className="inline-flex items-center gap-1.5">
            <Tag size={13} className="text-[#4BAF47]" /> {story.categories[0]}
            {story.categories.length > 1 && ` +${story.categories.length - 1}`}
          </span>
        </div>
        <h3 className="text-xl font-extrabold leading-snug text-[#24231D] mb-3">
          <Link to={`/stories/${story.slug}`} className="hover:text-[#4BAF47] transition-colors line-clamp-2">
            {story.title}
          </Link>
        </h3>
        <p className="text-[#878680] leading-relaxed line-clamp-2 mb-5">{story.excerpt}</p>
        <Link to={`/stories/${story.slug}`} className="mt-auto text-[#4BAF47] font-bold text-sm inline-flex items-center gap-1 hover:gap-2 transition-all">
          Read Story <span aria-hidden>→</span>
        </Link>
      </div>
    </article>
  );
}
